// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"15":"953ce3eb","484":"6d39b5a4","513":"6a7cad61","767":"d083b4d8","996":"1755e043"}[chunkId] + ".js";
};